export default "__VITE_ASSET__99bb5e51__"